(function () {
    function visibleThumbnailItems(gallery) {
      return Array.from(gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]')).filter((item) => {
        return item.offsetParent !== null && item.querySelector('button');
      });
    }
  
    function activeThumbnailIndex(items) {
      const activeIndex = items.findIndex((item) => item.querySelector('button[aria-current]'));
      return activeIndex >= 0 ? activeIndex : 0;
    }

    function gallerySlider(gallery) {
      return gallery.querySelector('[id^="Slider-Gallery"]');
    }

    function visibleMediaItems(gallery) {
      const slider = gallerySlider(gallery);
      if (!slider) return [];

      return Array.from(slider.children).filter((item) => {
        return item.matches('[data-media-id]') && item.offsetParent !== null;
      });
    }

    function currentMediaItem(gallery) {
      const items = visibleMediaItems(gallery);
      if (!items.length) return null;
      return items[activeMediaIndex(gallery)] || items[0];
    }

    function visibleGalleryDots(gallery) {
      return Array.from(gallery.querySelectorAll('[data-skim1-gallery-dot]')).filter((dot) => {
        const target = dot.dataset.skim1GalleryTarget;
        const targetItem = target ? gallery.querySelector(`[id^="Slider-Gallery"] [data-media-id="${target}"]`) : null;
        const isTargetVisible = targetItem && targetItem.offsetParent !== null;
        dot.hidden = !isTargetVisible;
        return isTargetVisible;
      });
    }

    function activeMediaIndex(gallery) {
      const slider = gallerySlider(gallery);
      const items = visibleMediaItems(gallery);
      if (!slider || !items.length) return 0;

      const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
      if (activeIndex >= 0 && Math.abs(items[activeIndex].offsetLeft - slider.scrollLeft) < 2) return activeIndex;

      const sliderCenter = slider.scrollLeft + slider.clientWidth / 2;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.clientWidth / 2;
        const distance = Math.abs(itemCenter - sliderCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function updateDotState(gallery) {
      const dotsWrap = gallery.querySelector('.skim1-gallery-dots');
      if (!dotsWrap) return;

      const items = visibleMediaItems(gallery);
      const dots = visibleGalleryDots(gallery);
      const shouldShowDots = items.length > 1 && dots.length > 1;

      dotsWrap.classList.toggle('hidden', !shouldShowDots);
      if (!shouldShowDots) return;

      const currentIndex = activeMediaIndex(gallery);
      const currentItem = items[currentIndex];

      dots.forEach((dot, index) => {
        const isActive = currentItem
          ? dot.dataset.skim1GalleryTarget === currentItem.dataset.mediaId
          : index === currentIndex;

        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function updateZoomButtonState(gallery) {
      const zoomButton = gallery.querySelector('[data-skim1-gallery-zoom]');
      if (!zoomButton) return;

      const currentItem = currentMediaItem(gallery);
      const targetToggle = currentItem?.querySelector('.product__modal-opener--image .product__media-toggle');
      const isAvailable = Boolean(targetToggle);

      zoomButton.classList.toggle('is-visible', isAvailable);
      zoomButton.toggleAttribute('hidden', !isAvailable);
      if (targetToggle?.dataset.mediaId) {
        zoomButton.dataset.skim1GalleryZoomTarget = targetToggle.dataset.mediaId;
      } else {
        delete zoomButton.dataset.skim1GalleryZoomTarget;
      }
    }

    function scrollToMedia(gallery, targetMediaId) {
      const slider = gallerySlider(gallery);
      const targetItem = targetMediaId
        ? visibleMediaItems(gallery).find((item) => item.dataset.mediaId === targetMediaId)
        : null;

      if (!slider || !targetItem) return;

      visibleMediaItems(gallery).forEach((item) => item.classList.remove('is-active'));
      targetItem.classList.add('is-active');
      slider.scrollTo({
        left: targetItem.offsetLeft,
        behavior: 'smooth',
      });

      updateDotState(gallery);
      updateZoomButtonState(gallery);
      window.setTimeout(() => updateDotState(gallery), 260);
      window.setTimeout(() => updateZoomButtonState(gallery), 260);
    }
  
    function galleryNavItemCount(gallery) {
      const thumbItems = visibleThumbnailItems(gallery);
      const mediaItems = visibleMediaItems(gallery);
      return Math.max(thumbItems.length, mediaItems.length);
    }

    function updateArrowState(gallery) {
      const arrows = gallery.querySelector('.skim1-gallery-arrows');
      const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
  
      const items = visibleThumbnailItems(gallery);
      const prevButtons = [
        arrows?.querySelector('button[name="previous"]'),
        thumbnails?.querySelector(':scope > button[name="previous"]'),
      ].filter(Boolean);
      const nextButtons = [
        arrows?.querySelector('button[name="next"]'),
        thumbnails?.querySelector(':scope > button[name="next"]'),
      ].filter(Boolean);
      const mediaItems = visibleMediaItems(gallery);
      const hasGalleryDots = mediaItems.length > 1 && visibleGalleryDots(gallery).length > 1;
      const navItemCount = galleryNavItemCount(gallery);
  
      const isSingleVariantGroup = gallery.hasAttribute('data-variant-group-single');
      const hideNav = navItemCount < 2 && !hasGalleryDots;

      arrows?.classList.toggle('hidden', hideNav || isSingleVariantGroup);
      thumbnails?.classList.toggle('skim1-thumbnail-slider--single', items.length < 2);
      thumbnails?.classList.toggle('hidden', isSingleVariantGroup);
      updateZoomButtonState(gallery);
      if (navItemCount < 2) {
        updateDotState(gallery);
        return;
      }

      const currentIndex = items.length >= 2 ? activeThumbnailIndex(items) : activeMediaIndex(gallery);
      const maxIndex = items.length >= 2 ? items.length - 1 : mediaItems.length - 1;
      prevButtons.forEach((button) => button.toggleAttribute('disabled', currentIndex <= 0));
      nextButtons.forEach((button) => button.toggleAttribute('disabled', currentIndex >= maxIndex));
    }
  
    function moveProductGallery(gallery, direction) {
      const thumbItems = visibleThumbnailItems(gallery);
      if (thumbItems.length >= 2) {
        const currentIndex = activeThumbnailIndex(thumbItems);
        const nextIndex = direction === 'next'
          ? Math.min(currentIndex + 1, thumbItems.length - 1)
          : Math.max(currentIndex - 1, 0);

        if (nextIndex === currentIndex) return;

        const nextButton = thumbItems[nextIndex].querySelector('button');
        if (nextButton) {
          nextButton.click();
          window.setTimeout(() => updateArrowState(gallery), 0);
        }
        return;
      }

      const mediaItems = visibleMediaItems(gallery);
      if (mediaItems.length < 2) return;

      const currentIndex = activeMediaIndex(gallery);
      const nextIndex = direction === 'next'
        ? Math.min(currentIndex + 1, mediaItems.length - 1)
        : Math.max(currentIndex - 1, 0);

      if (nextIndex === currentIndex) return;

      const nextMediaId = mediaItems[nextIndex]?.dataset?.mediaId;
      if (!nextMediaId) return;

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(nextMediaId, false);
      } else {
        scrollToMedia(gallery, nextMediaId);
      }

      window.setTimeout(() => updateArrowState(gallery), 0);
    }

    function bindGalleryNavDelegation(gallery) {
      if (gallery.dataset.skim1NavDelegation === 'true') return;
      gallery.dataset.skim1NavDelegation = 'true';

      gallery.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest(
            '.skim1-gallery-arrows button[name="previous"], .skim1-gallery-arrows button[name="next"], [id^="GalleryThumbnails"] > button[name="previous"], [id^="GalleryThumbnails"] > button[name="next"]'
          );
          if (!button || !gallery.contains(button)) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          moveProductGallery(gallery, button.name === 'next' ? 'next' : 'previous');
        },
        true
      );
    }
  
    function refreshGallery(gallery) {
      if (!gallery) return;

      updateArrowState(gallery);
      updateDotState(gallery);
      updateZoomButtonState(gallery);
    }

    function initGallery(gallery) {
      if (!gallery || gallery.dataset.skim1GalleryReady === 'true') return;
      gallery.dataset.skim1GalleryReady = 'true';
  
      const arrows = gallery.querySelector('.skim1-gallery-arrows');
      const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
  
      const zoomButton = gallery.querySelector('[data-skim1-gallery-zoom]');

      bindGalleryNavDelegation(gallery);

      zoomButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const currentItem = currentMediaItem(gallery);
        const targetToggle = currentItem?.querySelector('.product__modal-opener--image .product__media-toggle');
        targetToggle?.click();
      });
  
      if (thumbnails) {
        new MutationObserver(() => updateArrowState(gallery)).observe(thumbnails, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['aria-current', 'class', 'disabled', 'hidden', 'style'],
        });
      }

      const slider = gallerySlider(gallery);
      if (slider) {
        slider.addEventListener('scroll', () => {
          window.clearTimeout(gallery.skim1GalleryDotsTimeout);
          gallery.skim1GalleryDotsTimeout = window.setTimeout(() => {
            updateDotState(gallery);
            updateZoomButtonState(gallery);
          }, 60);
        }, { passive: true });
      }

      gallery.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-skim1-gallery-dot]');
        if (dot && gallery.contains(dot)) {
          event.preventDefault();
          scrollToMedia(gallery, dot.dataset.skim1GalleryTarget);
          return;
        }

        if (event.target.closest('[id^="GalleryThumbnails"] button')) {
          window.setTimeout(() => updateArrowState(gallery), 0);
        }
      });

      refreshGallery(gallery);
    }

    function relatedProductsTrack(section) {
      return section.querySelector('[data-related-products-track]');
    }

    function relatedProductsPagination(section) {
      return section.querySelector('[data-related-products-pagination]');
    }

    function relatedProductsItems(section) {
      const track = relatedProductsTrack(section);
      if (!track) return [];

      return Array.from(track.children).filter((item) => item.classList.contains('related-products__item'));
    }

    function activeRelatedProductsIndex(section) {
      const track = relatedProductsTrack(section);
      const items = relatedProductsItems(section);
      if (!track || !items.length) return 0;

      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.clientWidth / 2;
        const distance = Math.abs(itemCenter - trackCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function buildRelatedProductsDots(section) {
      const pagination = relatedProductsPagination(section);
      const items = relatedProductsItems(section);
      if (!pagination) return;

      if (pagination.dataset.relatedProductsDotsCount === String(items.length)) return;

      pagination.innerHTML = '';
      pagination.dataset.relatedProductsDotsCount = String(items.length);

      items.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'related-products__dot';
        dot.setAttribute('aria-label', `Go to related product ${index + 1}`);
        dot.dataset.relatedProductsDot = '';
        dot.dataset.relatedProductsIndex = String(index);
        pagination.appendChild(dot);
      });
    }

    function updateRelatedProductsDots(section) {
      const pagination = relatedProductsPagination(section);
      const items = relatedProductsItems(section);
      if (!pagination) return;

      buildRelatedProductsDots(section);

      const shouldShow = items.length > 0;
      pagination.classList.toggle('hidden', !shouldShow);
      pagination.toggleAttribute('hidden', !shouldShow);
      pagination.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (!shouldShow) return;

      const currentIndex = activeRelatedProductsIndex(section);

      items.forEach((item, index) => {
        item.classList.toggle('is-active', index === currentIndex);
      });

      pagination.querySelectorAll('[data-related-products-dot]').forEach((dot, index) => {
        const isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function scrollToRelatedProduct(section, index) {
      const track = relatedProductsTrack(section);
      const items = relatedProductsItems(section);
      const targetItem = items[index];
      if (!track || !targetItem) return;

      track.scrollTo({
        left: targetItem.offsetLeft,
        behavior: 'smooth',
      });

      updateRelatedProductsDots(section);
      window.setTimeout(() => updateRelatedProductsDots(section), 260);
    }

    function initRelatedProducts(section) {
      if (!section) return;
      if (section.dataset.skim1RelatedProductsReady === 'true') {
        updateRelatedProductsDots(section);
        return;
      }

      const track = relatedProductsTrack(section);
      const pagination = relatedProductsPagination(section);
      if (!track || !pagination) return;

      section.dataset.skim1RelatedProductsReady = 'true';

      track.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(section.skim1RelatedProductsDotsTimeout);
          section.skim1RelatedProductsDotsTimeout = window.setTimeout(() => updateRelatedProductsDots(section), 60);
        },
        { passive: true }
      );

      pagination.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-related-products-dot]');
        if (!dot) return;

        event.preventDefault();
        scrollToRelatedProduct(section, Number(dot.dataset.relatedProductsIndex || 0));
      });

      updateRelatedProductsDots(section);
      window.requestAnimationFrame(() => updateRelatedProductsDots(section));
      window.setTimeout(() => updateRelatedProductsDots(section), 300);
    }

    function initRelatedProductsAll(scope) {
      scope.querySelectorAll('product-recommendations.related-products').forEach(initRelatedProducts);
    }
  
    function initAll(scope) {
      scope
        .querySelectorAll('product-info[data-update-url="true"] media-gallery')
        .forEach(initGallery);

      initRelatedProductsAll(scope);
    }
  
    document.addEventListener('DOMContentLoaded', () => initAll(document));
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('skim1:gallery-updated', (event) => {
      const gallery = event.target.closest?.('media-gallery') || event.target;
      if (gallery?.matches?.('media-gallery')) {
        window.requestAnimationFrame(() => refreshGallery(gallery));
      }
    });
    document.addEventListener('product-recommendations:loaded', (event) => initRelatedProducts(event.target));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = event?.data?.sectionId;
        if (!sectionId) return;

        document
          .querySelectorAll(`product-info[data-section="${sectionId}"] media-gallery`)
          .forEach((gallery) => {
            window.requestAnimationFrame(() => refreshGallery(gallery));
          });
      });
    }
  })();
  
